export enum SwimPhase {
    GENERAL = 'General',
    OVERWATER = 'Overwater',
    UNDERWATER = 'Underwater',
    TRANSITION = 'Transition'
}